module.exports = __webpack_public_path__ + "img/cov-home.91f9f2e2.jpg";